import { uuidWrapper } from 'src/app/shared/helpers/uuid';
import { IUnique } from '../definitions/interfaces';
import { ID } from '../definitions/types';
import { IntegrationDetail } from '../interfaces/integration-detail.interface';
import { BaseModel } from './base.model';

export enum ElementDefinitionTarget {
    Workroads = 'Workroads'
}

export function enumToString(e: ElementDefinitionTarget) {
    if (e === ElementDefinitionTarget.Workroads) {
        return 'Workroads';
    }
    return '';
}



const INITIAL = {
    connectionString: '',
    id: uuidWrapper.uuid(),
    name: '',
    type: ElementDefinitionTarget.Workroads
};

export class IntegrationModel extends BaseModel implements IntegrationDetail {

    connectionString!: string;
    id!: ID;
    name!: string;
    type!: ElementDefinitionTarget;

    constructor(obj: IUnique) {
        super(obj);
    }

    protected initialize(obj: Partial<IntegrationDetail>): void {
        if (obj) {
            this.connectionString = obj.connectionString ?? INITIAL.connectionString;
            this.id = obj.id ?? INITIAL.id;
            this.name = obj.name ?? INITIAL.name;
            this.type = obj.type ?? INITIAL.type;
        }
    }



}

